import React, { memo } from "react";
import { ReactComponent as Logo } from "../../assets/images/Logo.svg";
import { ReactComponent as FooterLogo } from "../../assets/images/FooterLogo.svg";

import { useFormTo } from "../../hooks/useFormTo";
import { useShopifyApp } from "../../hooks/useShopifyApp";

import { StyledLink } from "./styles";

const LogoLink = ({ to = "/migrations/list", isFooter }) => {
  const { prefix } = useFormTo();
  const isShopifyApp = useShopifyApp();

  return (
    <StyledLink to={`${prefix}${to}`} $disabled={isShopifyApp}>
      {isFooter ? <FooterLogo /> : <Logo />}
    </StyledLink>
  );
};

export default memo(LogoLink);
